// The API Worker's absolute origin, baked at build time. Empty = same-origin
// (local dev serves each SPA via Vite and proxies /api). Extracted from api.ts
// so the runtime Supabase boot (supabase.ts) can use it without an import
// cycle — api.ts imports supabase.ts.
export const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');
